export default __webpack_public_path__ + "static/media/1.fdc6be37.jpg";